import { useContext } from 'react'
import { RouteLocationContext } from './route_location_provider'

export const useRouteLocationForm = () => {
    return useContext(RouteLocationContext)
}